import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'LocalGluons';
import { t } from '../../../../../locale';

import detailStyles from '../../Details.jss';

const ShowTimesButton = ({ navigation, item }) => {
    const onShowTimesPress = () => {
        navigation.navigate('Showtimes', {
            seriesName: item.data.name || item.getTitle(),
            channelId: item.getChannelId(),
            endTime: Date.now(),
            programId: item.getId()
        });
    };

    return (
        <Button
            style={{
                button: detailStyles.button
            }}
            isSecondary
            iconName="rotate_right"
            title={t('COMMON.SHOWTIMES')}
            onPress={onShowTimesPress}
        />
    );
};

ShowTimesButton.propTypes = {
    navigation: PropTypes.shape({}).isRequired,
    item: PropTypes.shape({}).isRequired
};

export default ShowTimesButton;
